var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 33,
    viewBox: "0 0 50 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9581 26.8126V21.656C23.9581 20.5243 23.0187 19.5937 21.875 19.5937H20.8006C19.9338 20.2341 18.8681 20.6252 17.7081 20.6252C16.5444 20.6252 15.4819 20.2341 14.6156 19.5937H13.5413C12.3938 19.5937 11.4581 20.5243 11.4581 21.656V26.8126H23.9581Z",
    fill: "#4860AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8331 15.4686C20.8331 17.1772 19.434 18.5623 17.7081 18.5623C15.9822 18.5623 14.5831 17.1772 14.5831 15.4686C14.5831 13.7599 15.9822 12.3748 17.7081 12.3748C19.434 12.3748 20.8331 13.7599 20.8331 15.4686Z",
    fill: "#4860AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5831 8.76572C14.5831 9.62003 13.8836 10.3126 13.0206 10.3126C12.1577 10.3126 11.4581 9.62003 11.4581 8.76572C11.4581 7.91142 12.1577 7.21887 13.0206 7.21887C13.8836 7.21887 14.5831 7.91142 14.5831 8.76572Z",
    fill: "#943939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6669 18.5623H31.25V22.6874H41.6669V18.5623Z",
    fill: "#943939"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8331 26.8126V4.12515C45.8331 1.85685 43.9575 0 41.6669 0H8.33313C6.04 0 4.16625 1.85685 4.16625 4.12515V26.8126H0V28.8748C0 31.1425 1.87375 33 4.16687 33H45.8337C48.1244 33 50 31.1425 50 28.8748V26.8126H45.8331ZM41.6669 18.5623V14.4371V10.3126V4.12515H31.25H27.0831H8.33313V26.8126H11.4581H23.9581H27.0831H31.25H41.6669V22.6874V18.5623Z",
    fill: "#555555"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 18.5623V14.4371H41.6669V10.3126H31.25V4.12515H27.0831V26.8126H31.25V22.6874V18.5623Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCall);
export default __webpack_public_path__ + "static/media/video-call.e84bbfd0d8bd0762d2e43b0423de394d.svg";
export { ForwardRef as ReactComponent };